<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M20.6769 18.0826C20.6769 18.0826 19.0565 16.5013 19.0565 14.1477V10.1148C19.0565 6.31484 16.0011 3.22581 12.2531 3.22581C8.50505 3.22581 5.44971 6.31484 5.44971 10.1148V14.1477C5.44971 16.4277 3.82926 18.0703 3.81689 18.0948L2.77783 19.1368H21.7778L20.6893 18.0826H20.6769ZM5.51156 17.911C6.05583 17.0652 6.68669 15.7535 6.68669 14.1477V10.1148C6.68669 6.98903 9.18538 4.45161 12.2531 4.45161C15.3208 4.45161 17.8195 6.98903 17.8195 10.1148V14.1477C17.8195 15.7658 18.4256 17.0652 18.9823 17.911H5.51156ZM12.8716 3.22581H11.6346V2H12.8716V3.22581ZM12.8716 19.1613H14.1086C14.1086 20.1787 13.2798 21 12.2531 21C11.2264 21 10.3976 20.1787 10.3976 19.1613H11.6346C11.6346 19.5045 11.9191 19.7742 12.2531 19.7742C12.5871 19.7742 12.8716 19.5045 12.8716 19.1613Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
